




































import StringHelper from '@/mixins/StringHelper.vue';
import { Component, Mixins } from 'vue-property-decorator';


@Component({
    props: [
        "creditCards",
        "activeCard"
    ]
})
export default class CreditCardsDialog extends Mixins(StringHelper) {
    public creditCardIcon(brand): string {
        return `fab fa-cc-${brand}`;
    }
};
